import React, { useEffect } from 'react'
import { useModal } from './useModal'
import { errorEmitter } from '../services/axios-instance'
import ErrorModal from '../components/modals/error-modal/error-modal'

export const useErrorHandler = () => {
	const { showModal } = useModal()

	useEffect(() => {
		const handleError = (event) => {
			const { message } = event.detail
			showModal(
				<ErrorModal description={message} />
			)
		}

		errorEmitter.addEventListener('apiError', handleError)
		return () => errorEmitter.removeEventListener('apiError', handleError)
	}, [showModal])
}